
    import { IonBadge, IonIcon,IonNote,IonImg,IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu } from '@ionic/vue';
    import { computed, defineComponent } from 'vue';
    import { storeToRefs } from 'pinia';
    import { currentUserStore } from '@/stores/currentUser'
    import { useMensajesUnreadStore } from '@/stores/mensajesUnread';
    import userAuth from '@/composables/userAuth';
    import tools from "@/composables/tools";
import { setPendingNavigationVisit } from '@/composables/navigationVisits';
import { calendarOutline, calculatorOutline, logoEuro, logoWhatsapp, personOutline, ribbonOutline, bagOutline, documentTextOutline, mailOutline, homeOutline } from 'ionicons/icons';
  
    export default defineComponent({
      components: { IonBadge, IonIcon,IonImg,IonNote,IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu},

      setup() {
        const currentUser = currentUserStore()
        const Auth = userAuth()
        const unreadStore = useMensajesUnreadStore()
        const { count: unreadCount } = storeToRefs(unreadStore)
        const unreadMenuBadge = computed(() => {
          const n = unreadCount.value
          return n > 99 ? '99+' : String(n)
        })

        const trackMenuVisit = (visitKey: string) => {
          setPendingNavigationVisit(visitKey);
          tools().setLog(`Navegación menú: ${visitKey}`);
        };

        const preload_Tarifas = () => {
          tools().setLog('Pulsa para ver tarifas')
        }
                
        const asistencia = ()=>{
          window.open('whatsapp://send?phone=' + process.env.VUE_APP_WHATSAPP_HELP + '&text=' + encodeURI('Tengo problemas con la aplicación. ¿Puedes ayudarme?'))
          tools().setLog('Solicitaron ayuda','warning')
        }

        const abrirNormasEscuela = () => {
          tools().setLog('Pulsó en Normas de la escuela')
          const url = 'https://galidancia.com/normas/'
          const opened = window.open(url, '_blank')
          if (!opened) window.location.href = url
        }

        return {
          currentUser,
          Auth,
          userAuth,
          currentUserStore,
          trackMenuVisit,
          preload_Tarifas,
          calendarOutline,
          calculatorOutline,
          logoEuro,
          personOutline,
          logoWhatsapp,
          documentTextOutline,
          ribbonOutline,
          bagOutline,
          mailOutline,
          homeOutline,
          unreadCount,
          unreadMenuBadge,
          asistencia,
          abrirNormasEscuela,
          tools
        }
      },
    });
  